(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neythkari-video-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  // ── Drag-to-scroll (smooth, momentum, no snap) ───────────────────────────────
  document.querySelectorAll('.nk-vc__track').forEach(function(track) {
    var isDown     = false;
    var startX     = 0;
    var scrollLeft = 0;
    var dragged    = false;
    var lastX      = 0;
    var velocity   = 0;
    var rafId      = null;

    track.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      isDown     = true;
      dragged    = false;
      velocity   = 0;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      startX     = e.pageX - track.getBoundingClientRect().left;
      lastX      = e.pageX;
      scrollLeft = track.scrollLeft;
      track.style.cursor     = 'grabbing';
      track.style.userSelect = 'none';
    });

    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      track.style.cursor     = '';
      track.style.userSelect = '';
      // Momentum glide after release
      (function glide() {
        if (Math.abs(velocity) < 0.5) { velocity = 0; return; }
        velocity *= 0.92;
        track.scrollLeft -= velocity;
        rafId = requestAnimationFrame(glide);
      })();
      setTimeout(function() { dragged = false; }, 100);
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x    = e.pageX - track.getBoundingClientRect().left;
      var walk = x - startX;
      velocity = e.pageX - lastX;
      lastX    = e.pageX;
      if (Math.abs(x - startX) > 4) dragged = true;
      track.scrollLeft = scrollLeft - walk;
    });

    // Expose dragged state on the element so card click can check it
    Object.defineProperty(track, '_dragged', { get: function() { return dragged; } });
  });

  // ── Arrow scrolling ─────────────────────────────────────────────────────────────
  document.querySelectorAll('.nk-vc__arrow').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id    = btn.getAttribute('data-vc-id');
      var dir   = parseInt(btn.getAttribute('data-vc-dir'), 10);
      var vp    = document.getElementById('nk-vc-' + id);
      if (!vp) return;
      var track = vp.querySelector('.nk-vc__track');
      var card  = track.querySelector('.nk-vc__card');
      if (!card) return;
      track.scrollBy({ left: dir * (card.offsetWidth + 16) * 2, behavior: 'smooth' });
    });
  });

  // ── Card click → product page (skip if drag, skip if ATC) ────────────────────────
  document.querySelectorAll('.nk-vc__form').forEach(function(form) {
    form.addEventListener('click', function(e) { e.stopPropagation(); });
  });

  document.querySelectorAll('.nk-vc__card[data-product-url]').forEach(function(card) {
    card.addEventListener('click', function() {
      var track = card.closest('.nk-vc__track');
      if (track && track._dragged) return;
      window.location.href = card.getAttribute('data-product-url');
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
